module.exports = __webpack_public_path__ + "media/images/athletes/3443-813d7e2bfb16cec9362728a41b1b48c7.png";